'use strict';

class DunningSend {
  constructor($scope, $location, $routeParams, invoiceService, dunningService, validationService, shipmentMethodsService, recipientService, StoreService, userService, Notification) {
    this.$scope = $scope;
    this.$location = $location;
    this.invoiceService = invoiceService;
    this.dunningService = dunningService;
    this.validationService = validationService;
    this.shipmentMethodsService = shipmentMethodsService;
    this.recipientService = recipientService;
    this.userService = userService;
    this.Notification = Notification;
    this.cart = new StoreService('id');
    this.dunningCart = new StoreService('id');

    this.number = $routeParams.number;
  }

  $onInit() {
    this.today = moment().format('YYYY-MM-DD');
    this.ehfEnabled = false;
    this.alert = {};
    this.invoice = {};
    this.sinceDueDate = moment().from(this.today);
    this.defaultDunningText = null;

    this.recipient = {};

    this.options = {
      ehf: false,
      eFaktura: false,
      print: this.features.indexOf('ISSUE_WITHOUT_SEND') !== -1
    };
    this.method = {
      ehf: false,
      eFaktura: false,
      email: false,
      paper: true,
      print: false
    };
    this.copy = {
      sms: false,
      email: false
    };
    this.hotmailWarning = false;

    // this.addAdminFee();

    this.fees = {
      eligibleForCollectionNotice: true,
      paidAmount: 0,
      dunningFee: 0,
      interest: {
        rate: 0,
        amount: 0
      },
      history: [],
      total: {
        dunningFee: 0,
        interest: 0
      }
    };

    this.dunning = {
      recipient: {
        icd: '9908',
        organisationNumber: null
      },
      shipment: {
        ehf: {},
        paper: {},
        email: [{
          address: null
        }],
        sms: [{
          mobileNumber: null
        }],
        copy: {
          email: [{
            address: null
          }]
        }
      }
    };

    this.$scope.$watch('$ctrl.dunning.debtCollectionNotice', (val) => {
      if (val) {
        this.ehfEnabled = false;
        if (this.method.ehf) {
          this.select('paper');
          this.Notification.info('Inkassovarsel kan ikke sendes som EHF. Forsendelsesmåte er endret til papir.');
        }
        if (this.invoice.international) {
          this.dunning.dunningText = 'If the invoice is not paid by the due date it will be sent to a collection agency.';
        } else {
          this.dunning.dunningText = 'Dersom regningen ikke betales innen forfall vil saken overføres til inkasso.';
        }
      } else {
        if (this.invoice.international) {
          this.ehfEnabled = false;
          this.dunning.dunningText = 'Our records indicate that this invoice has not been paid.';
        } else {
          this.ehfEnabled = true;
          this.dunning.dunningText = 'Vi kan dessverre ikke se å ha mottatt Deres betaling for denne regning.';
        }
      }
    });

    // Update cart
    this.$scope.$watch('$ctrl.dunning.dunningFee', (val) => {
      const item = {
        id: 'dunningFee',
        price: this.fees.dunningFee,
        name: 'Gebyr'
      };

      if (val) {
        this.dunningCart.add(item);
      } else {
        this.dunningCart.remove(item);
      }
    });

    this.$scope.$watch('$ctrl.dunning.interest', (val) => {
      const item = {
        id: 'interest',
        price: this.fees.interest.amount,
        name: 'Renter'
      };

      if (val) {
        this.dunningCart.add(item);
      } else {
        this.dunningCart.remove(item);
      }
    });

    this.$scope.$watch('$ctrl.copy.email', (val) => {
      const item = {
        id: 'copyEmail',
        price: this.prices.invoice.emailCopy,
        name: 'Kopi på e-post'
      };

      if (val) {
        this.cart.add(item);
      } else {
        this.cart.remove(item);
      }
    });

    this.$scope.$watch('$ctrl.copy.sms', (val) => {
      const item = {
        id: 'sms',
        price: this.prices.common.sms,
        name: 'SMS'
      };

      if (val) {
        this.cart.add(item);
      } else {
        this.cart.remove(item);
      }
    });

    this.$scope.$watch('$ctrl.method', () => {
      this.alert = {};
    });

    this.$scope.$watchGroup([
      '$ctrl.hotmailWarning',
      '$ctrl.dunning.shipment.email[0].address'
    ], (val) => {
      if (val[0]) {
        if (val && !this.validationService.isMicrosoft(val[1]).valid) {
          this.alert = {
            type: 'warning',
            message: this.validationService.isMicrosoft(val[1]).message
          };
        } else {
          this.alert = {};
        }
      }
    });

    this.load();
  }

  load() {
    this.invoiceService.get(this.number)
      .then((resp) => {
        let text = 'Vi kan dessverre ikke se å ha mottatt Deres betaling for denne regning.';
        if (resp.data.international) {
          text = 'Our records indicate that this invoice has not been paid.';
        }

        this.invoice = resp.data;

        this.ehfEnabled = !this.invoice.international;

        this.sinceDueDate = moment(this.invoice.dueDate, 'YYYY-MM-DD').from(this.today);

        angular.extend(this.dunning, {
          invoiceNumber: resp.data.number,
          interest: false,
          dunningFee: false,
          debtCollectionNotice: false,
          dunningText: text,
          shipment: {
            paper: resp.data.recipient.address,
            email: [{
              address: resp.data.recipient.email
            }],
            sms: [{
              mobileNumber: resp.data.recipient.mobile ? resp.data.recipient.mobile.replace('+47', '') : null,
              message: `${this.originator.name} har sendt deg en purring, se purringen på: `
            }],
            copy: {
              email: [{
                address: resp.data.recipient.email ? resp.data.recipient.email : null
              }]
            }
          }
        });

        this.shipmentMethodsService.forPreviousDocument('invoice', this.invoice.number, 'dunning', angular.isObject(this.invoice.international))
          .then((methods) => {
            methods.data.available.map((method) => {
              if (method in this.options) {
                this.options[method] = true;
              }
            });

            // build recipient
            this.recipientService.get(this.invoice.recipient.number)
              .then((json) => {
                if (!json.data.endUserMessage) {
                  return json.data;
                } else {
                  this.alert = {
                    type: 'error',
                    message: json.data.endUserMessage
                  };
                }
              })
              .then((recipient) => {
                this.recipient = recipient;
              });
          });

        // Add items to cart
        this.dunningCart.add({
          id: 'total',
          price: this.invoice.total,
          name: 'Fakturabeløp'
        }, true);

        this.select('paper');

        // get fees
        this.dunningService.fees(this.number)
          .then((resp2) => {
            if (!resp2.data.dunningFee) {
              this.disabled = true;
            }

            angular.extend(this.fees, resp2.data);

            // Add items to cart
            this.fees.total.dunningFee = 0;
            this.fees.total.interest = 0;

            resp2.data.history.forEach((item) => {
              if (item.dunningFee) {
                this.fees.total.dunningFee += item.dunningFee;
              }

              if (item.interest) {
                this.fees.total.interest += item.interest;
              }
            }, this);

            if (this.fees.total.dunningFee > 0) {
              this.dunningCart.add({
                id: 'historyFee',
                price: this.fees.total.dunningFee,
                name: 'Gebyr',
                inHistory: true
              });
            }

            if (this.fees.total.interest > 0) {
              this.dunningCart.add({
                id: 'historyInterest',
                price: this.fees.total.interest,
                name: 'Renter',
                inHistory: true
              });
            }

            this.dunningCart.add({
              id: 'paidAmount',
              price: this.fees.paidAmount,
              name: 'Innbetalt på faktura'
            }, true);
          });
      });
  }

  calcTotal() {
    let total = 0;
    this.dunningCart.get().forEach((item) => {
      if (item.id === 'paidAmount') {
        if (this.invoice.international) {
          total -= parseFloat(item.price, 10);
        } else {
          total += parseFloat(item.price, 10);
        }
      } else {
        total += parseFloat(item.price, 10);
      }
    });

    return total;
  }

  addCopyEmail() {
    this.dunning.shipment.copy.email.push({address: null});
  }

  removeCopyEmail(index) {
    this.dunning.shipment.copy.email.splice(index, 1);

    //recalculate cart
    this.updateCartEmailCopy();

    // reindex
    this.dunning.shipment.copy.email.forEach((item, i) => {
      item.number = i + 1;
      return this.dunning.shipment.copy.email;
    });
  }

  countValidEmails() {
    var cnt = 0;
    this.dunning.shipment.copy.email.forEach(function (email) {
      var x = email.address;
      if ((x && x.length)) {
        cnt++;
      }
    });
    return cnt;
  }

  updateCartEmailCopy() {
    if (this.copy.email) {
      var count = this.countValidEmails();
      this.cart.add({
        id: 'copyEmail',
        price: this.prices.invoice.emailCopy * count,
        name: 'Kopi på e-post'
      }, true);
    }
  }

  addAdminFee() {
    if (this.prices.addAdminFee === true) {
      const admFeeItem = {
        id: 'admFee',
        price: 35,
        name: 'Administrasjonsgebyr'
      };

      this.cart.add(admFeeItem);
    }
  }

  updateCart(name) {
    // Cleanup first
    this.cart.reset();

    // this.addAdminFee();

    // Add back optionals if enabled
    if (this.copy.email) {
      var count = this.countValidEmails();
      this.cart.add({
        id: 'copyEmail',
        price: this.prices.invoice.emailCopy * count,
        name: 'Kopi på e-post'
      });
    }
    if (this.copy.sms) {
      this.cart.add({
        id: 'sms',
        price: this.prices.common.sms,
        name: 'SMS'
      });
    }

    // Paper
    if (name === 'paper') {
      this.cart.add({
        id: 'paper',
        price: this.prices.invoice.paper,
        name: 'Papir'
      });
    }

    // Print
    else if (name === 'print') {
      this.cart.add({
        id: 'print',
        price: this.prices.invoice.print,
        name: 'Skriv ut selv'
      });
    }

    // EHF
    if (name === 'ehf') {
      this.cart.add({
        id: 'ehf',
        price: this.prices.invoice.ehf,
        name: 'EHF'
      });
    }

    // eFaktura
    else if (name === 'eFaktura') {
      this.cart.add({
        id: 'eFaktura',
        price: this.prices.invoice.eFaktura,
        name: 'eFaktura'
      });
    }

    // E-mail
    else if (name === 'email') {
      this.cart.add({
        id: 'email',
        price: this.prices.invoice.email,
        name: 'E-post'
      });
    } else {
      return false;
    }
  }

  select(method) {
    // set inactive all
    this.method = {
      ehf: false,
      eFaktura: false,
      email: false,
      paper: false,
      print: false
    };

    // set selected active
    this.method[method] = true;

    // update cart
    this.updateCart(method);
  }


  send() {
    $('button.submit').prop('disabled', true);

    let clone = angular.copy(this.dunning);
    this.dunning.shipment = {};

    if (this.method.email) {
      this.dunning.shipment.email = clone.shipment.email;
    }

    // EHF
    else if (this.method.ehf) {
      this.dunning.shipment.ehf = {};
    }

    // eFaktura
    else if (this.method.eFaktura) {
      this.dunning.shipment.eFaktura = {
        avtaleGiro: false
      };
      // disable attachments
      this.attachment = false;
    }

    // Paper
    else if (this.method.paper) {
      this.dunning.shipment.paper = clone.shipment.paper;
    }

    // SMS
    if (this.copy.sms) {
      this.dunning.shipment.sms = [{
        mobileNumber: clone.shipment.sms[0].mobileNumber || null,
        message: clone.shipment.sms[0].message || null
      }];
    }

    // Copy email
    if (this.copy.email) {
      var emailCopies = [];

      clone.shipment.copy.email.forEach(function (email) {
        var x = email.address;
        if ((x && x.length)) {
          emailCopies.push({
            address: x || null,
            customMessage: null
          });
        }
      });

      this.dunning.shipment.copy = {
        email: emailCopies
      };
    }

    this.dunningService.issue(this.dunning)
      .then(() => this.$location.path(`/regning/${this.invoice.number}`))
      .catch((err) => {
        $('button.submit').prop('disabled', false);

        this.alert = {
          type: 'error',
          message: err.data.endUserMessage
        };

        this.dunning = clone;
      });
  }
}

DunningSend.$inject = ['$scope', '$location', '$routeParams', 'invoiceService', 'dunningService', 'validationService', 'shipmentMethodsService', 'recipientService', 'StoreService', 'userService', 'Notification'];

const dunningSend = {
  bindings: {
    originator: '<',
    features: '<',
    prices: '<',
    countries: '<'
  },
  controller: DunningSend,
  templateUrl: 'dunning/send.html'
};

angular
  .module('SendRegning')
  .component('dunningSend', dunningSend)
  .config(($routeProvider) => {
    $routeProvider
      .when('/purring/kladd/:number/send', {
        title: 'Send purring',
        template: '<dunning-send originator="$resolve.originator" features="$resolve.features" prices="$resolve.prices" countries="$resolve.countries" />',
        resolve: {
          prices: (commonService) => commonService.getPrices(),
          features: (userService) => userService.get().then((resp) => resp.data.features),
          originator: (originatorService) => originatorService.get().then((resp) => resp.data),
          countries: (commonService) => commonService.getCountries()
        },
        noSidebar: true,
        overlay: true,
        secure: true
      });
  });
